import 'dayjs/locale/de';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import Link from '~/components/Link';
import { DEFAULT_REGION, type Region } from '~/utils/region';

dayjs.extend(utc);
dayjs.extend(timezone);

export function formatDate(
  unixTimestamp: number,
  region: Region = DEFAULT_REGION
) {
  return dayjs(unixTimestamp * 1000)
    .tz(region.timeZone)
    .locale(region.lang)
    .format('DD MMM YY, h:mm A');
}

type Author = {
  name: string;
  path: string;
  title: string;
};

type Props = {
  author: Author;
  className?: string;
  publishedDate?: number;
  title: string;
};

type BylineProps = Omit<Props, 'title'>;

export function ArticleByline({
  author,
  className,
  publishedDate
}: BylineProps) {
  return (
    <div
      className={`text-caption-grey flex flex-wrap items-center gap-4 ${className ?? ''}`}
    >
      {publishedDate && (
        <>
          <span>{formatDate(publishedDate)}</span>
          <span className="select-none">•</span>
        </>
      )}
      <Link to={author.path} external className="underline hover:text-gray-700">
        {author.name}
      </Link>
    </div>
  );
}

function FeatureMetadata({ title, author, publishedDate }: Props) {
  return (
    <div className="content-width flex w-full flex-col items-center gap-2 text-center lg:gap-4">
      <div className="text-hero text-balance">{title}</div>
      <ArticleByline
        author={author}
        className="justify-center"
        publishedDate={publishedDate}
      />
    </div>
  );
}

export function Header({ title, author, publishedDate, className }: Props) {
  return (
    <div
      className={`flex w-full items-center justify-center bg-white py-10 text-black ${className ?? ''}`}
    >
      <FeatureMetadata
        title={title}
        author={author}
        publishedDate={publishedDate}
      />
    </div>
  );
}
